"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SongwriterAccountCard = void 0;
const react_1 = __importDefault(require("react"));
const AccountCard_1 = __importDefault(require("@Components/Cards/AccountCard"));
const navigation_1 = __importDefault(require("@App/navigation"));
const common_1 = require("@Const/common");
const SongwriterAccountCard = (props) => {
    const { songwriterData, openPopup, viewDetails = true } = props;
    return (react_1.default.createElement(AccountCard_1.default, { name: songwriterData.name, totalWorks: songwriterData.totalWorks, isValidationStatusWrong: false, openPopup: openPopup, viewDetails: viewDetails, link: navigation_1.default.songwriter.catalog.root(songwriterData.id), icon: common_1.ICONS.songwriterHub, blueImageFilter: false }));
};
exports.SongwriterAccountCard = SongwriterAccountCard;
exports.default = exports.SongwriterAccountCard;
